import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Back to home")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Reset Game")

import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import { useDoors } from '@/services/stores/doors';
import { useAppState, useGameState } from '@/services/composition';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { send } = useAppState()
const state = useGameState()

const { t } = useI18n()
const { findDoor } = useDoors()

const countdown = computed(() => {
  return `${Math.round(state.value.context.countdown)}`
})

const pauseText = computed(() => {
  return state.value.context.isPaused ? 'Play' : 'Pause'
})

const doorText = computed(() => {
  const id = state.value.context.doorHovered
  if (id === -1) return ''

  const door = findDoor(id)
  return t(`game.temperature.${door.temperature}`)
})

return (_ctx: any,_cache: any) => {
  const _component_ui_btn = _resolveComponent("ui-btn")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_ui_btn, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(send)('GAME_BACK_HOME')))
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _createVNode(_component_ui_btn, {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(send)('GAME_RESET')))
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createVNode(_component_ui_btn, {
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(send)('GAME_TOGGLE_PAUSE')))
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(pauseText)), 1)
      ]),
      _: 1
    }),
    _createElementVNode("p", null, _toDisplayString(_unref(countdown)), 1),
    _createElementVNode("p", null, "Door is " + _toDisplayString(_unref(doorText)), 1)
  ]))
}
}

})